module.exports = __webpack_public_path__ + "static/logo-7d66ea75d44a50798e31e00bf0c8ae90.png";